import generateAsyncRouteComponent from '../generateAsyncRouteComponent';

export default {
  path: 'careers-at-bravissimo/vacancies/',
  component: generateAsyncRouteComponent({
    loader: () => import('./containers/VacanciesContainer'),
  }),
};
